<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Protocolli</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovoProtocollo" class="mb-2" v-if="!isViewMode">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(dataProtocollo)="{ item }">
                            {{ formatDate(item.dataProtocollo) }}
                        </template>
                        <template #cell(dataInizioTrattamento)="{ item }">
                            {{ formatDate(item.dataInizioTrattamento) }}
                        </template>
                        <template #cell(dataFineTrattamento)="{ item }">
                            {{ formatDate(item.dataFineTrattamento) }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row" v-if="!isViewMode">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Protocollo" variant="outline-success" @click="onClickModificaProtocollo(item)">
                                    <font-awesome-icon icon="edit"></font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Elimina Protocollo" variant="outline-danger" @click="onClickEliminaProtocollo(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-adi-protocolli-edit-component ref="mdlRsaAdiProtocolliEditComponent" @saveSuccess="onSaveSuccess"></rsa-adi-protocolli-edit-component>
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaAdiProtocolliEditComponent from "./RsaAdiProtocolliEditComponent.vue";

export default {
    name: "RsaAdiProtocolliListComponent",
    mixins: [UtilityMixin],
    components: { RsaAdiProtocolliEditComponent, ModalError },
    props: {
        isViewMode: { type: Boolean, default: false },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaadiprotocollo",
            listKey: 0,
            items: [],
            idAccettazione: null,
            fields: [
                { key: "numeroProtocollo", label: "N. Protocollo" },
                { key: "tipologia", label: "Tipologia" },
                { key: "livello", label: "Livello" },
                { key: "dataProtocollo", label: "Data Protocollo" },
                { key: "dataInizioTrattamento", label: "Data Inizio Trattamento" },
                { key: "dataFineTrattamento", label: "Data Fine Trattamento" },
                { key: "distretto", label: "Distretto" },
                { key: "actions", label: "", class: "sa-table-column-action-double" },
            ],
            jsonDataAccettazione: {},
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData(me.idAccettazione);
        },
    },
    methods: {
        loadData(jsonDataAccettazione) {
            let me = this;
            this.jsonDataAccettazione = jsonDataAccettazione;
            me.idAccettazione = jsonDataAccettazione.id || null;
            me.$emit("beforeLoadData");
            let params = { page: me.currentPage, forPage: me.perPage };
            if (me.idAccettazione) {
                params.idAccettazione = me.idAccettazione;
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, params, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
            me.$emit("afterLoadData", me.items);
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData");
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onClickNuovoProtocollo() {
            let me = this;
            me.$refs.mdlRsaAdiProtocolliEditComponent.show(this.jsonDataAccettazione);
        },
        onClickModificaProtocollo(item) {
            let me = this;
            me.$refs.mdlRsaAdiProtocolliEditComponent.showModifica(item.id, this.jsonDataAccettazione);
        },
        onClickEliminaProtocollo(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler eliminare il protocollo selezionato?", {
                    title: "Elimina Protocollo",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteProtocollo(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteProtocollo(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.deleteProtocolloSuccess, me.deleteProtocolloError);
        },
        deleteProtocolloSuccess() {
            let me = this;
            me.$bvToast.toast("Protocollo eliminato correttamente", {
                title: "Protocollo ADI",
                solid: true,
                variant: "success",
                autoHideDelay: 3000,
                appendToast: true,
            });
            me.loadData(me.idAccettazione);
        },
        deleteProtocolloError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onSaveSuccess() {
            let me = this;
            me.loadData(this.jsonDataAccettazione);
        },
    },
};
</script>

<style></style>
